import React from 'react';
import { Grid, Button } from '@mui/material';
import TabelaPerguntas from './TabelaPerguntas';

const App = () => {

  return (
    <Grid>    
        <TabelaPerguntas />
    </Grid>
  );
};

export default App;
